/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Import self-hosted fonts
import "./src/fonts/fonts.css"

export const onRouteUpdate = ({ location, prevLocation }) => {

  let currentPathName = location.pathname;
  let oldPathname = prevLocation ? prevLocation.pathname : null;
  if (currentPathName === "/cost-saving-calculator/" || currentPathName === "/cost-saving-calculator") {
    if (oldPathname !== "/cost-saving-calculator/" && oldPathname !== "/cost-saving-calculator" && oldPathname !== null) {
      window.location.href = location.pathname;
    }
  }
}